import { render, staticRenderFns } from "./ImpressaoPecas.vue?vue&type=template&id=08c1154e&"
import script from "./ImpressaoPecas.vue?vue&type=script&lang=js&"
export * from "./ImpressaoPecas.vue?vue&type=script&lang=js&"
import style0 from "./ImpressaoPecas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports